var _rect, _rect2, _g, _rect3, _g2, _line, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaturation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 75.3333,
    height: 78,
    rx: 5,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1007_95",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 38,
    height: 80
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.001,
    y: 80,
    width: 80,
    height: 37,
    transform: "rotate(-90 40.001 80)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1007_95)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1595 14.501C42.0045 14.538 43.6734 15.6058 44.4811 17.266L61.6706 52.5959C62.4347 54.1664 62.3092 56.0245 61.3409 57.4779C57.5009 63.2414 50.8065 66.1127 44.3893 65.3904C37.7152 64.6391 31.7081 60.0696 29.3076 51.9629C29.1311 51.367 29.0727 50.7642 29.1188 50.1796L24.4143 58.9377C23.1288 61.3307 20.1479 62.228 17.7563 60.9417C15.3647 59.6554 14.468 56.6727 15.7535 54.2796L35.7305 17.0903C36.6041 15.4639 38.3145 14.4639 40.1595 14.501ZM30.995 46.6869C31.4672 46.3177 32.0153 46.0294 32.6246 45.8487C35.2279 45.0769 37.9637 46.5629 38.735 49.1679C40.0511 53.6125 42.871 55.3188 45.4886 55.6134C47.5417 55.8445 49.6904 55.241 51.3829 53.9282L39.8444 30.2128L30.995 46.6869Z",
    fill: "url(#paint0_linear_1007_95)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1007_95",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 80
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: 80,
    width: 80,
    height: 40,
    transform: "rotate(-90 0.00012207 80)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1007_95)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1595 14.501C42.0045 14.538 43.6734 15.6058 44.4811 17.266L61.6706 52.5959C62.4347 54.1664 62.3092 56.0245 61.3409 57.4779C57.5009 63.2414 50.8065 66.1127 44.3893 65.3904C37.7152 64.6391 31.7081 60.0696 29.3076 51.9629C29.1311 51.367 29.0727 50.7642 29.1188 50.1796L24.4143 58.9377C23.1288 61.3307 20.1479 62.228 17.7563 60.9417C15.3647 59.6554 14.468 56.6727 15.7535 54.2796L35.7305 17.0903C36.6041 15.4639 38.3145 14.4639 40.1595 14.501ZM30.995 46.6869C31.4672 46.3177 32.0153 46.0294 32.6246 45.8487C35.2279 45.0769 37.9637 46.5629 38.735 49.1679C40.0511 53.6125 42.871 55.3188 45.4886 55.6134C47.5417 55.8445 49.6904 55.241 51.3829 53.9282L39.8444 30.2128L30.995 46.6869Z",
    fill: "url(#paint1_linear_1007_95)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.1666,
    y1: -2.18557e-8,
    x2: 40.1666,
    y2: 80,
    stroke: "url(#paint2_linear_1007_95)",
    strokeOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1007_95",
    x1: 6.69322,
    y1: 65.0024,
    x2: 48.326,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1890AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1007_95",
    x1: 6.69322,
    y1: 65.0024,
    x2: 48.326,
    y2: 13.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A844D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDD372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1007_95",
    x1: 39.6666,
    y1: 80,
    x2: 39.6666,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturation);
export default __webpack_public_path__ + "static/media/saturation.81d2ed8f199d98199f7bf5be7b887b1f.svg";
export { ForwardRef as ReactComponent };